import { composeIO } from 'react-compose-io'
import { itemDebitoIO } from './ItemDebito.IO'
import { ItemDebitoView } from './ItemDebito.View'

export const ItemDebito = composeIO(ItemDebitoView, itemDebitoIO)
